import { CicdProjectJobs, JobsTypes } from "~/pages/cicd/utils/cicdTypes";
import {
  AzureDevopsIcon,
  CircleCiIcon,
  GithubIcon,
  GitlabIcon,
  JenkinsIcon,
  KubernetesIcon,
} from "~/icons";

export const getProjectLogo = (projectType: string) => {
  switch (projectType) {
    case JobsTypes.Gitlab:
      return <GitlabIcon />;
    case JobsTypes.Github:
      return <GithubIcon />;
    case JobsTypes.Kubernetes:
      return <KubernetesIcon />;
    case JobsTypes.CircleCI:
      return <CircleCiIcon />;
    case JobsTypes.Azure:
      return <AzureDevopsIcon />;
    case JobsTypes.Jenkins:
      return <JenkinsIcon />;
    case JobsTypes.GithubActions:
      return JobsTypes.GithubActions;
    default:
      return <GithubIcon />;
  }
};

export const getProjectUrlFromJobs = (jobs: CicdProjectJobs["jobs"]) => {
  const firstJob = jobs?.edges?.at(0)?.node;
  switch (firstJob?.__typename) {
    case "GitlabJob":
      return firstJob.projectUrl;
    case "CircleCIJob":
      return firstJob.projectUrl;
    case "AzureDevopsJob":
      return firstJob.projectUrl;
    case "GithubJob":
      return `${firstJob.serverUrl}/${firstJob.repository}`;
    case "KubernetesJob":
    default:
      return "";
  }
};
